import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getSysType } from './ua';
export var genLoginType = function genLoginType() {
  return new Promise(function (resolve) {
    var loginType = '2';
    var sysType = getSysType(); // ios loginType === 2是全屏登录，安卓是弹窗登录
    // 此处做判断是由于ios弹窗登录第三方绑定手机号之后不会触发登录成功回调，暂时不好解决，所以改成全屏登录

    if (sysType === 'ios') {
      loginType = '2';
    }

    resolve(loginType);
  });
};